import classnames from 'classnames'
import { css } from 'emotion'
import * as React from 'react'
import Select from 'react-select'

import {
  DynamicSelectField,
  Field,
  FieldData,
  FieldSelectOption,
  FieldType,
  PublicClassNames,
  SelectField,
} from 'embed/constants'

import DynamicSelect from 'embed/components/DynamicSelect'
import { isNil } from 'embed/utils/object'

const applicationFieldStyles = require('../styles')
const filterStyles = require('embed/styles/filters')

export interface Props {
  colorError: string
  disabled?: boolean
  field: Field
  fieldData?: FieldData
  forceFocus?: boolean
  useFloatingLabelInputs?: boolean
}

export const SelectInput: React.FC<Props> = (props) => {
  const { useFloatingLabelInputs } = props
  let invalidValidationStyle = {}

  const isValid = props.fieldData?.isValid ?? false
  const shouldShowIsInvalid = props.fieldData?.shouldShowValidationStatus === true && isValid === false

  if (props.field.options.required && shouldShowIsInvalid) {
    invalidValidationStyle = {
      border: `1px solid  ${props.colorError}`,
    }
  }

  const getSelectFieldProps = (fieldProps, filterStylesField, field) => ({
    className: classnames(
      PublicClassNames.FormDropdown,
      filterStylesField.field,
      css`
        border-radius: ${fieldProps.borderRadiusSmall};
        font-size: ${fieldProps.fontSizeBase};
      `,
      { [applicationFieldStyles.floatingLabelSelect]: useFloatingLabelInputs },
    ),
    clearable: false,
    disabled: (fieldProps.fieldData?.isLoading || fieldProps.disabled) ?? false,
    name: fieldProps.field.key,
    onBlur: fieldProps.onBlur,
    onChange: (value: FieldSelectOption) => {
      // value is null when the user hits 'delete' while focused on the field
      const selectedValue = !isNil(value) ? value.value : null
      fieldProps.onChange(selectedValue)
    },
    options: fieldProps.selectOptions || field.options.selectOptions,
    removeSelected: false,
    searchable: field.options.searchable,
    style: invalidValidationStyle,
    value: fieldProps.fieldData?.value ?? '',
  })

  if (props.field.type === FieldType.DynamicSelect) {
    const dynamicSelectField = props.field as DynamicSelectField
    return (
      <DynamicSelect
        {...dynamicSelectField.options}
        {...getSelectFieldProps(props, filterStyles, dynamicSelectField)}
      />
    )
  }

  const selectField = props.field as SelectField
  return <Select {...getSelectFieldProps(props, filterStyles, selectField)} autoFocus={props.forceFocus} />
}
